export default {
  header: {
    signIn: 'Masuk',
    signUp: 'Daftar'
  },
  userMenu: {
    wallet: 'Dompet',
    withdraw: 'Tarik Dana',
    transaction: 'Transaksi',
    myBet: 'Taruhan Saya',
    rollover: 'Rollover',
    vault: 'Brankas',
    profile: 'Profil',
    settings: 'Pengaturan',
    signOut: 'Keluar',
    signOutTitle: 'Keluar',
    signOutContent: 'Jelajahi dunia yang penuh dengan hadiah dan permainan menarik!',
    signOutConfirm: 'Keluar',
    cancel: 'Batal'
  }
};
